export default __webpack_public_path__ + "static/media/testimonials.6b69d872.png";